import '../../resources/css/settings/ModalAccountDetail.scss';
import React, { Component } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { openModal, closeModal, popupModalConfirm } from '../../actions/index';
import AccountForm from './AccountForm';
import { doDeleteAccount, doGetAccountDetail } from '../../actions/settings/index';

class ModalAccountDetail extends Component {

    render() {
        const { openModal, closeModal, modalStatus, modalMessage, accountDetail, authToken, popupModalConfirm, doDeleteAccount} = this.props;
        let show = modalStatus === 'settingsAccount';
        let isAdd = modalMessage === 'add';
        let classModal = 'modal-settings-account-detail';
        let renderContent;
        if (show && (accountDetail || isAdd)) {
            let headerTitle = isAdd ? "Add new account" : accountDetail?.name;

            renderContent = (
                <Modal
                    show={show}
                    dialogClassName={ classModal }
                    centered
                    onHide={() => closeModal(null)}
                >
                    <Modal.Body>
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={6}>
                                    <span className='header-title'>{ headerTitle }</span>
                                </Col>
                                <Col sm={4} className='area-close-btn'>
                                { modalMessage === 'view' && !(accountDetail.seq === 0 || accountDetail.seq === 1)? <><span id="modal-account-detail-edit" className='icon-btn-edit-white-n' onClick={() => openModal("settingsAccount", 'edit', null, null)}></span>
                                <span id="modal-account-detail-delete" className='icon-btn-delete-white-n' onClick={() => { popupModalConfirm('Delete', 'icon-ico-failed', 'Really want to remove?', 300, () => doDeleteAccount(authToken, accountDetail.seq), null, false); closeModal(null);}}></span>
                                     </>: '' }
                                    
                                    <span className='area-icon-close-detail' onClick={() => closeModal(null)}><span className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            <AccountForm></AccountForm>
                        </div>
                    </Modal.Body>
                </Modal>
            )        
        } else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='area-settings-account-detail'>
                {renderContent}                
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        modalStatus: state.commonReducers.modalStatus,
        modalMessage: state.commonReducers.modalMessage,
        accountDetail: state.settingsReducers.accountDetail,
        authToken: state.loginReducers.authToken
    }
}

export default connect(
    mapStateToProps,
    { openModal, closeModal, doGetAccountDetail, popupModalConfirm, doDeleteAccount }
)(ModalAccountDetail)